import React, { Component } from "react";
import { connect } from "react-redux";

import { Wrapper, Scroll, Copy } from "app/NativeComponents/common";
import { List } from "app/NativeComponents/snippets";
import Conversation from "./Conversation";

import ToTextMessage from "./ToTextMessage";
import MessageNote from "./MessageNote";
import moment from "moment";

import { readTextMessage } from "app/NativeActions";
class MessageConversation extends Component {
  constructor(props) {
    super(props);

    this._scroll_view = React.createRef();
  }

  renderSendingMessage() {
    if (this.props.sending_message) {
      return (
        <ToTextMessage
          colors={this.props.colors}
          message_text={this.props.sending_message.message_text}
          date_created={moment().format()}
          sending_message={this.props.sending_message.sending_message}
          failed_to_send={this.props.sending_message.failed_to_send}
          failure_message={this.props.sending_message.failure_message}
        />
      );
    }
  }

  renderPostingNote() {
    if (this.props.posting_note) {
      return (
        <MessageNote
          colors={this.props.colors}
          message_text={this.props.posting_note.message_text}
          date_created={moment().format()}
          sending_message={this.props.posting_note.sending_message}
          failed_to_send={this.props.posting_note.failed_to_send}
        />
      );
    }
  }

  componentDidMount() {
    this._scroll_interval = setTimeout(() => {
      this.scrollToBottom();
    }, 250);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.selected_conversations !== this.props.selected_conversations ||
      prevProps.sending_message !== this.props.sending_message ||
      prevProps.posting_note !== this.props.posting_note
    ) {
      this._scroll_interval = setTimeout(() => {
        this.scrollToBottom();
      }, 250);
    }
  }

  componentWillUnmount() {
    clearInterval(this._scroll_interval);
  }

  scrollToBottom() {
    if (
      this.props.device == "desktop" &&
      this._scroll_view &&
      this._scroll_view.current
    ) {
      this._scroll_view.current.scrollTop = this._scroll_view.current.scrollHeight;
    } else if (
      this.props.device == "mobile" &&
      this._scroll_view &&
      this._scroll_view.current &&
      this._scroll_view.current.scrollToEnd
    ) {
      this._scroll_view.current.scrollToEnd({ animated: true });
    }
  }

  renderNoMessages() {
    if (
      this.props.selected_conversations &&
      this.props.selected_conversations.length == 0 &&
      !this.props.sending_message &&
      this.props.selected_to_number
    ) {
      return (
        <Wrapper
          style={{
            padding: 15,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Copy
            style={{
              textAlign: "center",
              color: this.props.colors.light_text_color,
              fontSize: 12
            }}
          >
            Start a conversation by typing a message below.
          </Copy>
        </Wrapper>
      );
    }
  }

  render() {
    return (
      <List
        scroll_ref={this._scroll_view}
        rowNumber={1}
        style={{
          flex: 1,
          maxHeight:
            (!this.props.is_expanded || this.props.isMobile) &&
            this.props.device !== "mobile"
              ? "100%"
              : "100%"
        }}
        scrollView={true}
        items={
          this.props.selected_conversations
            ? this.props.selected_conversations
            : []
        }
        infiniteScroll={true}
        itemStruture={({ item, index }) => {
          return (
            <Conversation
              key={index}
              is_latest_conversation={
                this.props.selected_conversations
                  ? index === this.props.selected_conversations.length - 1
                    ? true
                    : false
                  : false
              }
              is_first_conversation={index === 0 ? true : false}
              conversation={item}
              {...this.props}
            />
          );
        }}
        listFooter={() => {
          return (
            <Wrapper style={{ paddingBottom: 40 }}>
              {this.renderNoMessages()}
              {this.renderSendingMessage()}
              {this.renderPostingNote()}
            </Wrapper>
          );
        }}
        canRefresh={false}
        onRefresh={() => {}}
        is_refreshing={false}
        canLoadMore={false}
        isLoadingMore={false}
        onLoadMore={() => {}}
      />
    );
  }
}

const mapStateToProps = ({ auth, settings, native, message }) => {
  const { token, user } = auth;
  const { device, platform, isMobile } = native;
  const { colors } = settings;
  const { sending_message, posting_note } = message;
  return {
    token,
    user,
    device,
    platform,
    isMobile,
    colors,

    sending_message,
    posting_note
  };
};

export default connect(mapStateToProps, {
  readTextMessage
})(MessageConversation);
